module.exports = __webpack_public_path__ + "img/bBool.a0ada060.svg";